module.exports = __webpack_public_path__ + "static/bin_full-de9702a0903ad53528237624836eb5c7.svg";